<h1 mat-dialog-title >Deseja realmente deletar o custo extra? Essa ação não pode ser desfeita.</h1>
<div mat-dialog-actions>
  <button mat-button [mat-dialog-close]="[true]" cdkFocusInitial >{{ 'Confirm' | translate }}</button>
  <button mat-button [mat-dialog-close]="[false]" cdkFocusInitial >{{ 'Cancel' | translate }}</button>
</div>
